import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { KeyboardBackspace as KeyboardBackspaceIcon } from '@mui/icons-material';
import { Typography, Box, IconButton } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styles from './styles';
const BackButton = ({ onClick, sectionName, children }) => {
    const { t: text } = useTranslation();
    const navigate = useNavigate();
    const currentPillarName = window.location.href.split('/')[3] || ' ';
    const gaButtonAttributes = {
        'data-navigation-name': currentPillarName == 'goalsetting'
            ? 'Goals'
            : currentPillarName[0].toUpperCase() + currentPillarName.slice(1),
        'data-section-name': sectionName,
        'data-section-id': sectionName,
        'data-insight-id': 'Not applicable',
        'data-click-text': 'Back',
        'data-type': 'Button',
        'data-click-action': 'Back to previous page',
    };
    const handleOnClick = () => {
        if (onClick) {
            onClick();
        }
        else {
            navigate(-1);
        }
    };
    return (_jsx(Box, { sx: { mb: 2 }, children: _jsxs(IconButton, { size: 'small', sx: styles.button, disableRipple: true, onClick: () => handleOnClick(), ...gaButtonAttributes, children: [_jsx(KeyboardBackspaceIcon, { sx: styles.iconButton }), _jsxs(Typography, { variant: 'h5', sx: styles.iconButton, children: [text('BACK'), " ", children] })] }) }));
};
export default BackButton;
